import curator from './social-media-approver.module'
export default curator
